export const PARAM_SETTING = {
  BED_TYPES: 'bedTypes',
  LANDMARKS: 'landmarks',
  LANGUAGES: 'languages',
  PLACE_TYPES: 'placeTypes',
  PAYMENT_METHOD: 'paymentMethod',
  SERVICES: 'services',
  ROLES: 'roles',
  ROOM_NAMES: 'roomNames',
  FACILITIES: 'facilities',
  CANCEL_BOOKING_POLICY: 'cancelBookingPolicy',
};

export const LANGUAGE_LABEL = {
  VI: 'Tiếng Việt',
  EN: 'Tiếng Anh',
  FR: 'Tiếng Pháp',
  CN: 'Tiếng Trung',
  JP: 'Tiếng Nhật',
  KR: 'Tiếng Hàn',
};
